import { FormItem, NumberInput } from '@framework/form';
import React from 'react';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact';
import { RuleType } from '../../IRule';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';
import { MAX_ATTACHMENT_SIZE } from './maxAttachmentSize';

const fieldName = `rules.${RuleType.MaxDimension}`;

export interface IMaxDimensionRuleComponentProps {}

export function MaxDimensionRuleComponent(
  props: IMaxDimensionRuleComponentProps,
) {
  return (
    <FormItem
      name={`${fieldName}.value`}
      label="Dimensione Massima"
      help="Se non impostata, la dimensione massima per l'upload è di 100MB"
    >
      <$SpaceCompact block size="large">
        <NumberInput
          addonBefore="MB"
          name={`${fieldName}.value`}
          allowClear
          defaultValue={MAX_ATTACHMENT_SIZE}
        />
        <CustomValidationRuleMessage name={`${fieldName}.customMessage`} />
      </$SpaceCompact>
    </FormItem>
  );
}
